var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-tabela__header"},_vm._l((_setup.props.headers),function(header){return _c('div',{key:header.value,staticClass:"c-header__cell"},[_c('div',{staticClass:"c-cell c-cell__text"},[_vm._v(" "+_vm._s(header.text)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }